module.exports = __webpack_public_path__ + "static/media/get_matched.1ed56c27.png";